import axios from "./config";

const SCHEMA = "";

export function GetCities() {
  return axios.get(`${SCHEMA}/cities`);
}
